import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { AccomSupportService } from '../../common/services/accomsupport.service';
import { PaperExamineeRequestService } from '../process-paper-request/examinee/paper-examinee-request.service';
import { PaperRequestService } from '../service/paperrequest.service';
import { CommonService } from './../../../../views/services/common.service';
import { AppService } from '../../../../views/services/app.service';

@Component({
  selector: "app-paperrequestlanding",
  templateUrl: "./paperrequestlanding.component.html"
})
export class PaperRequestLandingComponent implements OnInit, OnDestroy {
  public examineeForm: FormGroup;
  public accomSupportForm: FormGroup;
  public tableData: any;
  public infoMsg: string;
  public count: any;
  public deleteDataDetails: any;
  private router: Router;

  constructor(
    private appService: AppService,
    public accomSupportService: AccomSupportService,
    public commonService: CommonService,
    public paperExamineeRequestService: PaperExamineeRequestService,
    public paperRequestService: PaperRequestService,
  ) {
  }

  ngOnInit() {
    this.paperExamineeRequestService.currentRequest = null;
    sessionStorage.removeItem("currentStudent");
    this.accomSupportForm = new FormGroup({
      taapin: new FormControl(),
      lastname: new FormControl(),
      firstname: new FormControl()
    });

    Observable.forkJoin(
      this.commonService.getDynContent('ACCOM_SUPPORT_INFO_MSG'),
      this.appService.getUserProfile().then(user => this.paperRequestService.getPendingPaperRequests(user.loggedInUser).toPromise()),
    ).subscribe(([infoMsg, response]) => {
      this.infoMsg = infoMsg;
      this.tableData = response.body;
      this.count = this.tableData.length;
      this.tableData.forEach(element => {
        if (element.REASONS) {
          element.REASONS = element.REASONS.replace(/\|/g, ",");
        }
        if (element.EXAMINEE_ACCOMMS) {
          element.EXAMINEE_ACCOMMS = element.EXAMINEE_ACCOMMS.replace(
            /\|/g,
            ","
          );
        }
        if (element.CONSULTANTS) {
          element.CONSULTANTS = element.CONSULTANTS.replace(/\|/g, ",");
        }
      });

    });
  }

  sendStudentDetails(list: any) {
    const studentDetails = {
      lastName: list.PNLASTNAME,
      firstName: list.PNFIRSTNAME,
      personId: list.PERSON_ID,
      taaPin: list.ACCOMMS_PIN,
      requestId: list.REQUEST_ID
    };
    sessionStorage.setItem("currentStudent", JSON.stringify(studentDetails));
  }

  filterResults() {
    this.accomSupportResults(this.accomSupportForm.value);
  }

  accomSupportResults(req: any) {
    this.accomSupportService.getAccomSupport(req).subscribe(
      error => {
        console.log("Error while loading list examinees");
      }
    );
  }


  ngOnDestroy() { }
  openDeleteModal(data) {
    this.deleteDataDetails = data;
    document.getElementById("deleteModal").style.display = "block";
  }
  onCloseHandled(id) {
    document.getElementById(id).style.display = "";
  }
  deleteRecord() {
    const details = {
      REQUEST_ID: this.deleteDataDetails.REQUEST_ID,
      PERSON_ID: this.deleteDataDetails.PERSON_ID
    };

    Observable.forkJoin(
      this.paperRequestService.deleteDocuments(details)
    ).subscribe(([documentDeleted]) => {
      const documents: any = documentDeleted;
      if (
        documents.status === 200 &&
        documents.body.status === "Deleted successfully"
      ) {
        Observable.forkJoin(
          this.paperRequestService.deleteRequestDetails(details)
        ).subscribe(([deletedRequest]) => {
          const request: any = deletedRequest;
          if (
            request.status === 200 &&
            request.body.status === "Deleted Request Successfully"
          ) {
            document.getElementById("deleteModal").style.display = "";
            this.ngOnInit();
          }
          if (
            request.status === 200 &&
            request.body.status === "Deleted Successfully"
          ) {
            document.getElementById("deleteModal").style.display = "";
            this.ngOnInit();
          }
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/paperrequestlanding/paperrequestlanding.component.ts